export default __webpack_public_path__ + "assets/models/f43f82564666047619eced0416189b39.gltf";